import { render, staticRenderFns } from "./indexContent.vue?vue&type=template&id=22ec6f71&scoped=true&"
import script from "./indexContent.vue?vue&type=script&lang=js&"
export * from "./indexContent.vue?vue&type=script&lang=js&"
import style0 from "./indexContent.vue?vue&type=style&index=0&id=22ec6f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec6f71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})


/* vuetify-loader */
import installDirectives from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Mutate from 'vuetify/lib/directives/mutate'
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Mutate,Resize})
